import { useTranslation } from 'react-i18next';
import { color, COLOR_VARIANTS, Icons, Tag, Typography, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';
import { SEATS_REMAINING_VARIANTS } from '@/constants/common.constants';
import { SeatsRemainingVariant } from '@/types/common.types';
import Styled from './SeatsRemaining.styled';

export function SeatsRemaining({
  seatsAvailable,
  variant = SEATS_REMAINING_VARIANTS.VARIANT_A,
  isPaxPage = false,
}: {
  seatsAvailable: number;
  variant: SeatsRemainingVariant;
  isPaxPage?: boolean;
}) {
  const { t } = useTranslation();
  const content = t('SearchResults.SeatsRemaining_Message', { seats: seatsAvailable, count: seatsAvailable }) as string;

  if (isPaxPage) {
    return (
      <Styled.Wrapper>
        <Typography color={COLOR_VARIANTS.CORAL100} component="span" variant={TYPOGRAPHY_VARIANT.CAPTIONREG}>
          {content}
        </Typography>
      </Styled.Wrapper>
    );
  }

  if (variant === SEATS_REMAINING_VARIANTS.VARIANT_B) {
    return (
      <Styled.Wrapper>
        <Icons.FlameIcon color={color(COLOR_VARIANTS.CORALPRESSED)} width="16px" height="16px" />
        <Typography color={COLOR_VARIANTS.CORALPRESSED} component="span" variant={TYPOGRAPHY_VARIANT.CAPTIONSEMBLD}>
          {content}
        </Typography>
      </Styled.Wrapper>
    );
  }
  return (
    <Tag
      appearance="crimson"
      type="tint"
      icon={<Icons.FlameIcon color={color(COLOR_VARIANTS.CORALPRESSED)} width="16px" height="16px" />}
    >
      {content}
    </Tag>
  );
}
